module.exports = __webpack_public_path__ + "static/img/7.44270ab1.png";